export default function scrollerSponsors() {
  const widgetName = 'scrollerSponsors';
  const widgetOpts = scrollerSponsorsOpts;
  const $widget = $(`#${widgetName}`);

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      setTimeout(() => {
        changeSponsorsStructure();
      }, 3000);
      clearInterval(interval);
    }
  }, 800);

  function changeSponsorsStructure() {
    const $majorSponsorTitle = $('#scrollerSponsors #majorSponsorTitleContainer');
    const $majorSponsorContainer = $('#scrollerSponsors .majorSponsor');
    const majorSponsorsTitle = $('#majorSponsorTitleContainer .homepageh1').text();

    if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
      $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
      $majorSponsorContainer.appendTo($('#major-sponsor-wrapper'));
      $('#major-sponsor-wrapper').prependTo($('#scrollerSponsors'));

      $('#majorSponsorTitleContainer .homepageh1').replaceWith(
        `<h2 class="major-sponsor-title">${majorSponsorsTitle}</h2>`,
      );
    }

    const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
    $('#sponsorsTitleContainer .homepageh1').replaceWith(
      `<h2 class="main-sponsors-title">${sponsorsTitleContent}</h2>`,
    );

    $('#scrollerSponsors').append('<div class="scroller-container">');
    $('#scrollerSponsors .sponsorWidgetContainer ').appendTo('.scroller-container');
    $('#scrollerSponsors #sponsorArrowLeft').appendTo('.scroller-container');
    $('#scrollerSponsors #sponsorArrowRight').appendTo('.scroller-container');
  }

  return saffire.widgets.sponsors($($widget), {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 6,
    bw: false,
    rotate: true,
  });
}
